import { useQuery } from 'react-query';
import { companyApi } from '../services/api';
import { CompanySettingsResponse } from '../types/companySettings';

export const COMPANY_SETTINGS_QUERY_KEY = 'companySettings';

export const useCompanySettingsQuery = (companyId?: number) =>
  useQuery<CompanySettingsResponse>(
    [COMPANY_SETTINGS_QUERY_KEY, companyId],
    () => companyApi.getSettings(),
    {
      enabled: !!companyId,
    }
  );
